import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useSunglassesProductData } from "../../../../../../../../context/context/product-context-hooks.js";
import { WITHOUT_RX, WITH_RX } from "../../../../../../components/RxableSelect/modules/EcommContent/components/RxableSelect/contants.js";
import { ChannelAvailability } from "../../../../../../../../types/types/product.js";
const SunglassesEcommContext = React.createContext({});
const useSunglassesEcommContext = () => React.useContext(SunglassesEcommContext);
const SunglassesEcommProvider = ({
  children
}) => {
  const {
    activeVariant: { channelAvailability },
    product: { isOfferedWithPrescriptions }
  } = useSunglassesProductData();
  const { isRxPriceFromEnabled } = useFeatureToggles();
  const [selectWithRxLens, setSelectWithRxLens] = React.useState(WITHOUT_RX);
  const shouldOpenConfigurator = (isOfferedWithPrescriptions && selectWithRxLens === WITH_RX) ?? false;
  const shouldDisplayFromPrice = Boolean(isRxPriceFromEnabled && shouldOpenConfigurator);
  const [isConfiguratorOpen, setIsConfiguratorOpen] = React.useState(false);
  const handleConfiguratorOpen = () => {
    setIsConfiguratorOpen(true);
  };
  const handleConfiguratorClose = () => {
    setIsConfiguratorOpen(false);
  };
  const productAction = React.useMemo(() => {
    if (shouldOpenConfigurator) {
      return channelAvailability === ChannelAvailability.ONLINE ? "OPEN_CONFIGURATOR" : "OPEN_CONFIGURATOR_UNAVAILABLE";
    }
    return channelAvailability === ChannelAvailability.ONLINE ? "ADD_TO_CART" : "ADD_TO_CART_UNAVAILABLE";
  }, [shouldOpenConfigurator, channelAvailability]);
  const value = React.useMemo(
    () => ({
      productAction,
      selectWithRxLens,
      setSelectWithRxLens,
      isConfiguratorOpen,
      handleConfiguratorOpen,
      handleConfiguratorClose,
      shouldOpenConfigurator,
      shouldDisplayFromPrice
    }),
    [
      isConfiguratorOpen,
      productAction,
      selectWithRxLens,
      shouldDisplayFromPrice,
      shouldOpenConfigurator
    ]
  );
  return /* @__PURE__ */ React.createElement(SunglassesEcommContext.Provider, { value }, children);
};
export {
  SunglassesEcommContext,
  SunglassesEcommProvider,
  useSunglassesEcommContext
};
//# sourceMappingURL=SunglassesEcommContext.js.map
